import { AdmService } from 'src/app/shared/services/adm.service';
import { Compania } from 'src/app/shared/models/compania';
import { Component, OnInit, ViewChild, AfterViewInit, Inject } from '@angular/core';
import { ConfigService } from 'src/app/shared/services/config.service';
import { defaultValueOrRangeValidator, isMobile, isMobileXL, toFormData } from 'src/app/shared/utils/helpers';
import { debounceTime, distinctUntilChanged, filter, finalize, forkJoin, startWith, switchMap, tap } from 'rxjs';
import { AbstractControl, FormBuilder, FormControl, FormGroup, FormGroupDirective, NgForm, Validators } from '@angular/forms';
import { LoggedService } from 'src/app/shared/services/logged.service';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Pais } from 'src/app/shared/models/pais';
import { Router } from '@angular/router';
import { SalesOrg } from 'src/app/shared/models/salesOrg';
import { SidenavService } from 'src/app/shared/services/sidenav.service';
import { SnackbarService } from 'src/app/shared/services/snackbar.service';
import { TablasService } from 'src/app/shared/services/tablas.service';
import { Deposito } from 'src/app/shared/models/deposito';
import { Cuenta } from 'src/app/shared/models/cuenta';

@Component({
  selector: 'app-depositos-dialog',
  templateUrl: './depositos-dialog.component.html'
})
export class DepositosDialogComponent implements OnInit {
  companias: Compania[] = [];
  salesOrgs: SalesOrg[] = [];
  mensaje: number = 0;
  form: FormGroup;
  idTipo: number;
  d: Deposito;
  codigoDEdit: number = -1;

  cuentasEncontradas: any;
  cuentaSeleccionada: Cuenta;
  fcAutocompleteCuenta = new FormControl('');
  hintC: string = ""
  loadingFcAutocompleteCuenta = false;
  minLengthTermCuenta = 2;

  constructor(private admService: AdmService,
    private configService: ConfigService,
    private dialog: MatDialog,
    private dialogRef: MatDialogRef<DepositosDialogComponent>,
    private fb: FormBuilder,
    private loggedService: LoggedService,
    private router: Router,
    private sidenav: SidenavService,
    private snackBarService: SnackbarService,
    private tablasService: TablasService,
    @Inject(MAT_DIALOG_DATA) private data: any) {
    this.form = this.fb.group({

      descripcion: ['', [Validators.required]],
      idCompania: ['', Validators.required],
      idSalesOrg: ['', Validators.required],
      idPais: [''],
      idPlanta: ['', [Validators.required]],
      autor: [''],
      cliente: [false],
      habilitacion: [true],
      // nombreClienteDireccionEntrega: ['', [this.requiredIfClienteFalse('cliente')]],
      // nroClienteDireccionEntrega: ['', [this.requiredIfClienteFalse('cliente')]],
      codigo: [0]
    })
    if (data.idTipo != null) {
      this.idTipo = data.idTipo;
    }
    if (data.d != null) {
      this.codigoDEdit = data.d.codigo
      this.d = data.d

    }
  }
  public Etiquetas: {
    Habilitacion: string,
    Descripcion: string,
    IdCompania: string,
    IdSalesOrg: string,
    IdPlanta: string,
    Cliente: string,
    Cuenta: string,
    NroClienteDireccionEntrega: string,
    NombreClienteDireccionEntrega: string

  }

  public Validaciones: {
    Compania: string
    SalesOrg: string
    Descripcion: string
    IdPlanta: string
    NroClienteDireccionEntrega: string,
    NombreClienteDireccionEntrega: string
  }

  ngOnInit(): void {


    this.dialogRef.beforeClosed().subscribe(() => this.dialogRef.close(this.mensaje));
    this.Etiquetas = {
      Habilitacion: this.configService.etiquetas.Habilitacion,
      Descripcion: this.configService.etiquetas.Descripcion,
      IdCompania: this.configService.etiquetas.Compania,
      IdSalesOrg: this.configService.etiquetas.SalesOrg,
      Cliente: this.configService.etiquetas.Depositos.Cliente,
      IdPlanta: this.configService.etiquetas.IdPlanta,
      Cuenta: this.configService.etiquetas.Cuenta,
      NroClienteDireccionEntrega: this.configService.etiquetas.Depositos.NroClienteDireccionEntrega,
      NombreClienteDireccionEntrega: this.configService.etiquetas.Depositos.NombreClienteDireccionEntrega


    }

    this.Validaciones = {

      Descripcion: this.configService.validaciones.Descripcion,
      Compania: this.configService.validaciones.Compania,
      SalesOrg: this.configService.validaciones.SalesOrg,
      IdPlanta: this.configService.validaciones.Depositos.IdPlanta,
      NroClienteDireccionEntrega: this.configService.validaciones.Depositos.NroClienteDireccionEntrega,
      NombreClienteDireccionEntrega: this.configService.validaciones.Depositos.NombreClienteDireccionEntrega

    }

    // this.fcAutocompleteCuenta.valueChanges
    //   .pipe(
    //     startWith(''),
    //     filter(res => {
    //       return typeof res != 'undefined' && res != null && res.length >= this.minLengthTermCuenta
    //     }),
    //     distinctUntilChanged(),
    //     debounceTime(1000),
    //     tap(() => {

    //       this.cuentasEncontradas = [];
    //       this.loadingFcAutocompleteCuenta = true;
    //     }),
    //     switchMap(value => this.tablasService.cCuentasparaDepositosAutocompleteSearch(this.loggedService.logged.idPais, this.form.controls['idCompania'].value, this.form.controls['idSalesOrg'].value, value)
    //       .pipe(
    //         finalize(() => {
    //           this.loadingFcAutocompleteCuenta = false
    //         }),
    //       )
    //     )
    //   )
    //   .subscribe((data: Cuenta[]) => {
    //     this.cuentasEncontradas = data;

    //   });
      // setTimeout(() => {
      //   this.form.get('nombreClienteDireccionEntrega')?.updateValueAndValidity();
      //   this.form.get('nroClienteDireccionEntrega')?.updateValueAndValidity();
      // });
    
      // this.form.get('cliente')?.valueChanges.subscribe(() => {
      //   this.form.get('nombreClienteDireccionEntrega')?.updateValueAndValidity();
      //   this.form.get('nroClienteDireccionEntrega')?.updateValueAndValidity();
      // });
    forkJoin([

      this.admService.cCompanias(this.loggedService.logged.idPais),
      this.admService.cSalesOrgs(this.loggedService.logged.idPais, this.loggedService.logged.idCompania),
      this.tablasService.cDepositoDB(this.codigoDEdit)

    ]).subscribe((data: [Compania[], SalesOrg[], Deposito]) => {

      if (data[0].length) {
        this.companias = data[0];
      }

      if (data[1].length) {
        this.salesOrgs = data[1];
      }

      if (this.idTipo == 1) {
        let paisPlaceHolder: Pais = new Pais();
        paisPlaceHolder.id = this.loggedService.logged.idPais;
        paisPlaceHolder.descripcion = "";
        this.form.controls['idPais'].setValue(paisPlaceHolder.id);
        if (this.companias.length) {
          this.form.controls['idCompania'].setValue(this.companias[0].id);
        }
        if (this.salesOrgs.length) {
          this.form.controls['idSalesOrg'].setValue(this.salesOrgs[0].id);
        }
      }

      if (typeof this.d != 'undefined') {
        if (this.codigoDEdit != -1) {
          if (data[2] != null) {

            this.form.controls['descripcion'].setValue(data[2].descripcion);
            this.form.controls['idCompania'].setValue(data[2].idCompania);
            this.form.controls['idPais'].setValue(data[2].idPais);
            this.form.controls['idSalesOrg'].setValue(data[2].idSalesOrg);
            this.form.controls['codigo'].setValue(data[2].codigo);
            this.form.controls['autor'].setValue(data[2].autor);
            this.form.controls['cliente'].setValue(data[2].cliente);
            this.form.controls['idPlanta'].setValue(data[2].idPlanta);
            this.form.controls['habilitacion'].setValue(data[2].habilitacion);
            // this.form.controls['nroClienteDireccionEntrega'].setValue(data[2].nroClienteDireccionEntrega);
            // this.form.controls['nombreClienteDireccionEntrega'].setValue(data[2].nombreClienteDireccionEntrega);

            this.form.markAsUntouched();
            this.form.markAsPristine();
          }
        }
      }

    });
  }

  // requiredIfClienteFalse(dependentField: string) {
  //   return (control: AbstractControl) => {
  //     if (!control.parent) return null; // Espera hasta que el formulario esté completo
  
  //     const dependentControl = control.parent.get(dependentField);
  //     if (dependentControl?.value === false && !control.value) {
  //       return { required: true };
  //     }
  //     return null;
  //   };
  // }
  
  compareCompanias(compLista: any, compD: any): boolean {
    if (typeof compLista != 'undefined' && typeof compD != 'undefined') {

      return compLista === compD;
    }
  }

  compareSalesOrgs(salesOrgLista: any, salesOrgD: any): boolean {
    if (typeof salesOrgLista != 'undefined' && typeof salesOrgD != 'undefined') {

      return salesOrgLista === salesOrgD;
    }
  }


  guardarDeposito() {

    switch (this.idTipo) {
      case 1:
        this.form.controls['autor'].setValue(this.loggedService.logged.userName);
        this.tablasService.aDeposito(this.form.value).subscribe((data: boolean) => {
          this.mensaje = this.idTipo;
          this.dialogRef.close();
        })
        break;

      case 2:

        this.tablasService
          .mDeposito(this.form.value)
          .subscribe((data: boolean) => {
            this.mensaje = this.idTipo;
            this.dialogRef.close();
          });
        break;
    }

  }

  // seleccionarCuenta(c: any) {

  //   if (c != "-1") {
  //     this.cuentaSeleccionada = c;

  //     this.form.controls['nombreClienteDireccionEntrega'].setValue(this.cuentaSeleccionada.nombre);
  //     this.form.controls['nroClienteDireccionEntrega'].setValue(this.cuentaSeleccionada.nroCliente);


  //   }
  //   else {

  //     this.cuentaSeleccionada = null;

  //     this.form.controls['nombreClienteDireccionEntrega'].reset();
  //     this.form.controls['nroClienteDireccionEntrega'].reset();
  //   }

  // }
  // getOptionTextCuenta(option) {
  //   if (option != null) {
  //     return option.displayValue;
  //   }
  // }
  // handleEmptyInputCuenta(event: any) {
  //   if (event.target.value === '' || event.target.value.length < this.minLengthTermCuenta) {
  //     this.limpiarCuenta(false);
  //   }
  // }

  // limpiarCuenta(resetFormControl: boolean) {
  //   this.cuentasEncontradas = [];
  //   this.seleccionarCuenta("-1");
  //   if (resetFormControl) {
  //     this.fcAutocompleteCuenta.setValue('');
  //   }

  // }

  isMobileXL() {
    return isMobileXL();
  }

  isMobile() {
    return isMobile();
  }

  clearInput(formControlName: string) {
    this.form.controls[formControlName].reset();
  }

  isInRole(rol: string): boolean {
    return this.loggedService.isInRole(rol);
  }

}
